/* DONE */

import styles from './UPCCodes.module.css'
import { useLanguageHook } from '../../../../../Hooks/use-context-hooks';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { PageText } from '../../../../../components/Text/Text';

const UPCCodes = ({ product }) => {
    const containerRef = useRef(null);
    const isInView = useInView(containerRef, { once: false, threshold: 0.5 });
    const pageTextRef = useRef(null);
    const pageTextInView = useInView(pageTextRef, { once: false, threshold: 0.5 });

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2, // Delay between each child animation
                delayChildren: 0.1,   // Initial delay before the first child starts animating
            }
        }
    };
    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 }
    };
    // const { language } = useLanguageHook()

    // const upcCodeText = language === "EN" ? product.upcCodeEN : product.upcCodeFR;
    const upcCodeText = product.upcCode;
    return (
        product &&
        <div className={styles.upcCodesSectionWrapper}>
            {/* <BodyContainer> */}
            <section className={styles.upcCodesContainer}>
                {/* <div className={styles.titleBox}>
                        <p className={styles.titleText}>UPC Codes</p>
                    </div> */}
                <div className={styles.upcCodeWrapper}>
                    {
                        upcCodeText.map((selectedUpcCode, index) => {
                            return (
                                <PageText key={index} type='productPageColorSwatch'>{selectedUpcCode}</PageText>
                                // <p key={index} className={styles.upcCodeText}>{selectedUpcCode}</p>

                            );
                        })
                    }
                </div>

            </section>
            {/* </BodyContainer> */}
        </div>
    );
};

export default UPCCodes;